import styled from '@emotion/styled';
import { spacing, color } from '@lightspeed/cirrus-tokens/utils';

export const Wrapper = styled('div')(({ dirty }) => ({
  display: 'flex',
  width: '100%',
  position: 'sticky',
  top: dirty ? '54px' : '-6px',
  transition: '0.2s top cubic-bezier(0, 1, 0.5, 1)',
  zIndex: 2,
  backgroundColor: `${color('snow')}`,
  borderBottom: `solid 1px ${color('snow-300')}`,
  height: '60px',
  padding: `${spacing(2)}`,
  [`.griffin &`]: {
    top: dirty ? '0' : 'auto',
  },
  [`@media print`]: {
    display: `none`,
  },
}));
